import { Component } from '@angular/core';
import { LoginComponent } from '@curbnturf/auth-components/src/lib/login/login.component';
import { IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'curbnturf-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  standalone: true,
  imports: [IonContent, LoginComponent],
})
export class LoginModalComponent {}
